import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { StoreProvider } from '@app/providers';
import { UserServices } from '@app/services';
import { AbstractResetComponent } from '..';

@Component({
    standalone: false,
    selector: 'app-ask-reset',
    templateUrl: './ask-reset.component.html',
    styleUrls: ['./ask-reset.component.scss'],
})
export class AskResetComponent
    extends AbstractResetComponent
    implements OnInit
{
    public askPasswordForm!: UntypedFormGroup;
    public submitted = false;

    constructor(
        router: Router,
        store: StoreProvider,
        userServices: UserServices,
        private formBuilder: UntypedFormBuilder
    ) {
        super(store, router, userServices);
    }

    ngOnInit() {
        this.askPasswordForm = this.formBuilder.group({
            email: [
                this.$email.value,
                Validators.compose([Validators.required, Validators.email]),
            ],
        });
    }

    public back() {
        this.router.navigate(['/login']);
    }

    public onSubmit() {
        this.submitted = true;
        if (this.askPasswordForm.valid) {
            this.$email.next(this.askPasswordForm.controls['email'].value);

            this.askNewPassword().subscribe({
                next: (value) => {
                    this.setToken(value.token);
                },
                complete: () => {
                    this.$showWaitingToken.next(true);
                    this.nextStep();
                },
                error: () => {
                    this.setError('ask-reset-sending-email');
                },
            });
        }
    }

    public updateFormByKey(key: string, value: any) {
        this.askPasswordForm.patchValue({ [key]: value });
    }

    public reset() {
        this.submitted = false;
        this.$showWaitingToken.next(false);
        this.removeError();
    }
}
